
import { fieldTypes } from "services/filterService";
import { VendorInvoiceFileStatusLabels } from "../invoiceConsts.ts";
import OutputInvoicePreview from "../vendor/vendorInvoiceFileOutput/OutputInvoicePreview";
import { Button, Tooltip } from "@material-ui/core";
import StatusLabel from "./StatusLabel";

export const filterConfig = [
    { type: fieldTypes.TEXT, title: 'Status', key: 'status', values: VendorInvoiceFileStatusLabels },
    { type: fieldTypes.DATERANGE, title: 'Received Date', key: 'receivedDate' },
    { type: fieldTypes.DATERANGE, title: 'Created Date', key: 'createdDate' },
];

export const getTableColumns = (setSelectedInvoice) => [
    {
        name: "File Name", key: 'fileUrl',
        component: (row) => {
            const fileName = row?.fileUrl?.split('/').pop();
            const nameWithoutExt = fileName?.replace(/\.[^/.]+$/, '');

            return <Tooltip title={nameWithoutExt}>
                <span>{nameWithoutExt}</span>
            </Tooltip>
        }
    },
    { name: "Sender", key: "sender" },
    { name: "Received Date", key: "receivedDate" },
    { name: "Created Date", key: "createdDate", selectedByDefault: true },
    {
        name: "Status",
        key: "statusLabel",
        component: (row) => <StatusLabel status={row.status} />
    },
    {
        name: "Parsing Output", key: "output",
        component: (row) => (
            <OutputInvoicePreview vendorInvoiceFileId={row.id} />
        )
    },
    {
        name: 'File', key: 'fileUrl',
        component: (row) => row?.fileUrl ? (
            <Button
                color='primary'
                aria-label="View File"
                onClick={() => {
                    setSelectedInvoice(row);
                }}
            >
                View File
            </Button>
        ) : <div>No File</div>
    },
    {
        name: "Invoice",
        key: "vendorInvoiceId",
        component: (row) =>
            !!row?.vendorInvoiceId && (
                <Button
                    color='primary'
                    aria-label="View Invoice"
                    onClick={() => {
                        const url = `/invoices/vendor?invoiceId=${row?.vendorInvoiceId}`;
                        window.open(url, "_blank", "noopener,noreferrer");
                    }}
                >
                    View Invoice
                </Button>
            )
    }

];
